import "./Footer.css";
const Footer = () => {
  return (
    <footer className="footer">
      Developed by{" "}
      <a href="https://vidakhalili.ir" target="_blank" rel="noreferrer">
        Vida Khalili
      </a>
    </footer>
  );
};

export default Footer;
